import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import CartItem from './CartItem'
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import { useDispatch } from 'react-redux';
import { openCart } from '../../app/cart/Cart';

export default function CartList() {

    const dispatch = useDispatch();

    const handleClose = () => { dispatch(openCart(false)); }

    return (
        <Box width={{ md: '490px' }} paddingX={'40px'}>
            <Box onClick={() => handleClose()} display={'flex'} justifyContent={'end'}>
                <CloseIcon sx={{ fill: '#1E353D', height: '30px', width: '30px', cursor: 'pointer' }} />
            </Box>
            <Grid container gap={'40px'} marginTop={'40px'}>
                <Grid size={12}>
                    <CartItem />
                </Grid>
                <Grid size={12}>
                    <Divider />
                </Grid>
                <Grid size={12}>
                    <CartItem />
                </Grid>
            </Grid>
            <Divider sx={{ marginTop: '40px', marginBottom: '20px' }} />
            <Box>
                <Box display={'flex'} justifyContent={'space-between'}>
                    <Typography variant="body1" fontSize={'1.125rem'} fontWeight={'bold'} color='text.secondary'>Subtotal:</Typography>
                    <Typography variant="body1" fontSize={'1.125rem'} fontWeight={'bold'} color='text.secondary'>240 €</Typography>
                </Box>
                <Typography variant="body1" marginTop={'20px'} marginBottom={'50px'} fontSize={'1.125rem'} color='text.secondary'>You will earn 240 points with this purchase.</Typography>
                <Button fullWidth variant='outlined' className='borderRadiusFlat borderWidth2 buttonPaddingY10 defaultBorderColor' sx={{ backgroundColor: 'text.secondary', color: 'text.primary' }}>CHECKOUT</Button>
            </Box>
        </Box>
    )
}
